var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.06874 16.6673C3.6104 16.6673 3.21804 16.5041 2.89165 16.1777C2.56526 15.8513 2.40207 15.459 2.40207 15.0007V5.00065C2.40207 4.54232 2.56526 4.14996 2.89165 3.82357C3.21804 3.49718 3.6104 3.33398 4.06874 3.33398H17.4021C17.8604 3.33398 18.2528 3.49718 18.5792 3.82357C18.9055 4.14996 19.0687 4.54232 19.0687 5.00065V15.0007C19.0687 15.459 18.9055 15.8513 18.5792 16.1777C18.2528 16.5041 17.8604 16.6673 17.4021 16.6673H4.06874ZM10.7354 10.834L4.06874 6.66732V15.0007H17.4021V6.66732L10.7354 10.834ZM10.7354 9.16732L17.4021 5.00065H4.06874L10.7354 9.16732ZM4.06874 6.66732V5.00065V15.0007V6.66732Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.67fc7a150542aa21651ff90f67c37239.svg";
export { ForwardRef as ReactComponent };